import request from "_private/utils/request";
// 获取 topRight 接口 车辆和司机数接口
export function getEmergencyVehicleAndDriver() {
  return request({
    url: "/emergencyBoardInfo/getEmergencyVehicleAndDriver",
    method: "post",
    headers: { type: "json" }
  });
}

//    各企业下的司机和车辆数
export function getEmergencyVehicleAndDriverOfCompary() {
  return request({
    url: "/emergencyBoardInfo/getEmergencyVehicleAndDriverOfCompary",
    method: "post",
    headers: { type: "json" }
  });
}
